import * as React from "react";
const SwipeRightIconSvg = (props) => (
  <svg width="60" height="60" viewBox="0 0 60 60" fill="none" xmlns="http://www.w3.org/2000/svg">
<rect width="60" height="60" rx="30" fill="white"/>
<path d="M33.9993 20.0022C20 22 14.0029 32 12.0015 42C17.0015 34.9986 23.9993 31.7984 33.9993 31.7984V39.9986L47.9986 25.9993L33.9993 12V20.0022Z" fill="#E77A45"/>
</svg>

);
export default SwipeRightIconSvg;
